import { render, staticRenderFns } from "./InstagramInstantwinApplicantListPage.vue?vue&type=template&id=2c90e82d&scoped=true"
import script from "./InstagramInstantwinApplicantListPage.vue?vue&type=script&lang=ts"
export * from "./InstagramInstantwinApplicantListPage.vue?vue&type=script&lang=ts"
import style0 from "./InstagramInstantwinApplicantListPage.vue?vue&type=style&index=0&id=2c90e82d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c90e82d",
  null
  
)

export default component.exports